/*=========================================================================================
  File Name: moduleSpaceActions.js
  Description: Space Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
// import store from "../store.js"
// import router from '@/router'

export default {
    // Set mails flag unread to true
    createSubmit({ commit }, payload) {
      var frm = new FormData()
      // var submitInfo = {"id": payload.id, "title": payload.title, "detail": payload.detail, "workspace_id": payload.workspace_id}
      const json = JSON.stringify(payload.param)
      const blob = new Blob([json], {
        type: 'application/json'
      })
      frm.append("document",  blob)
      for (var index in payload.files) {
        frm.append(index, payload.files[index])
      }
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/submit/create", frm, {headers:{'Content-Type': 'multipart/form-data'}}).then((response) =>{
          if(response.data.result == 'success'){
            commit("CREATE_SUBMIT", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    updateSubmit({ commit }, payload) {
      var frm = new FormData()
      for (var index in payload.files) {
        frm.append(index, payload.files[index])
      }
      // var submitInfo = {"id": payload.id, "title": payload.title, "size": payload.files.length, "files":files,  "detail": payload.detail}
      const json = JSON.stringify(payload.param)
      const blob = new Blob([json], {
        type: 'application/json'
      })
      frm.append("document",  blob)
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/submit/update", frm, {headers:{'Content-Type': 'multipart/form-data'}}).then((response) =>{
          if(response.data.result == 'success') {
            commit("UPDATE_SUBMIT", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    deleteSubmitFile({commit}, payload){
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/submit/update/"+ payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit("UPDATE_SUBMIT", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    deleteSubmit({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/submit/"+ payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("DELETE_SUBMIT", payload)
            }
            resolve(response)
          }
        )
        .catch((error) => { reject(error) })
      })
    },
    submitFileDonwload(context, payload){
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/submit/download/"+ payload.param, {responseType: 'blob'}).then((response)=>{
          const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));
          const link = document.createElement('a');
          link.href = url;
          // const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ')
          link.setAttribute('download', payload.name);
          document.body.appendChild(link);
          link.click();
          resolve(response)
        }).catch((error) => { reject(error) })
      })
    },
    getSubmit({ commit }, payload) {
      // var projectInfo = {"project_id": payload.project_Id}
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/submit/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_SUBMIT_LIST", response.data.data_list)
            }
            resolve(response)
          }).catch((error) => { reject(error) })
        })
    },
    setSubmitSearchQuery({ commit }, query){
        commit("SET_SUBMIT_SEARCH_QUERY", query)
    },
    getSubmitMember({ commit }, payload) {
      // var projectInfo = {"project_id": payload.project_Id}
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/submit/member/"+payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("SET_SUBMIT_MEMBER_LIST", response.data.data_list)
              resolve(response)
            }
            reject(response)
          }).catch((error) => { reject(error) })
        })
    },
    createSubmitMember({commit}, payload) {
      var frm = new FormData()
      var submitInfo = {"id": payload.id, "title": payload.title, "detail": payload.detail, "workspace_id": payload.workspace_id}
      const json = JSON.stringify(submitInfo);
      const blob = new Blob([json], {
        type: 'application/json'
      })
      frm.append("document",  blob)
      frm.append("file", payload.file)
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/submit/member/create", frm, {headers:{'Content-Type': 'multipart/form-data'}}).then((response) =>{
          if(response.data.result == 'success'){
            commit("CREATE_SUBMIT_MEMBER", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    deleteSubmitMember({ commit }, payload) {
      return new Promise((resolve, reject) => {
        axios.delete("/api/workspace/submit/member/"+ payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("DELETE_SUBMIT_MEMBER", payload)
              resolve(response)
            }
            reject(response)
          }
        ).catch((error) => { reject(error) })
      })
    },
    updateSubmitMemberScore({commit}, payload) {
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/submit/member/update/score", payload)
          .then((response) => {
            if(response.data.result == 'success'){
              commit("UPDATE_SUBMIT_MEMBER_SCORE", payload)
              resolve(response)
            }
            reject(response)
          }
        ).catch((error) => { reject(error) })
      })
    },
    updateSubmitMember({ commit }, payload) {
      var frm = new FormData()
      var submitInfo = {"id": payload.id, "title": payload.title, "detail": payload.detail}
      const json = JSON.stringify(submitInfo);
      const blob = new Blob([json], {
        type: 'application/json'
      })
      frm.append("document",  blob)
      frm.append("file", payload.file)
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/submit/member/update", frm, {headers:{'Content-Type': 'multipart/form-data'}}).then((response) =>{
          if(response.data.result == 'success'){
            commit("UPDATE_SUBMIT_MEMBER", response.data.data)
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    },
    fileDonwloadSubmitMembe(context, payload){
      return new Promise((resolve, reject) => {
        axios.get("/api/workspace/submit/member/download/"+ payload.param, {responseType: 'blob'}).then((response)=>{
          const url = window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', payload.name)
          // link.download = payload.name
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(url)
          document.body.removeChild(link)
          link.remove()
          resolve(response)
        }).catch((error) => { reject(error) })
      })
    },
    fileCompressSubmitMembe(context, payload){
      return new Promise((resolve, reject) => {
        axios.post("/api/workspace/submit/member/compress", payload).then((response)=>{
          if(response.data.result == 'success'){
            resolve(response)
          }
          reject(response)
        }).catch((error) => { reject(error) })
      })
    }

}
